import sliceCreator from '../../index.jsx';
import {CREATE_POST_SEASON_ACTIVITY} from '../../../constants/index.jsx';
const _createPostSeasonActivityAction = sliceCreator('CREATE_POST_SEASON_ACTIVITY', CREATE_POST_SEASON_ACTIVITY, 'post');

const { asyncAction: createPostSeasonActivityAction, reducer, clearData: clearCreatePostSeasonActivityAction } = _createPostSeasonActivityAction;

export default reducer;

export {
    createPostSeasonActivityAction,
    clearCreatePostSeasonActivityAction
}